"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingJobType = exports.DataFreshness = exports.YugiohRaritySliderLabels = exports.ExpansionSortOptions = exports.ChannelFilterOptions = exports.AnyYesNo = exports.CONDITIONS = exports.ConditionEnum = exports.CARDMARKET_CONDITIONS = exports.CARD_LANGUAGES = exports.CardLanguage = exports.SELLER_LEVELS = exports.SellerLevel = exports.REPUTATIONS = exports.Reputation = exports.CardmarketStatus = exports.PriceGuideMetrics = exports.PriceStategyTarget = exports.CardExtraAttribute = exports.GAME_IDS = exports.IdGame = exports.GAME_NAMES = exports.GameName = exports.Activity = exports.SUPPORTED_CURRENCIES = exports.InventoryFetchState = exports.SubscriptionId = exports.OutsetaSubscriptionId = exports.userHasPermission = void 0;
var arrayFromEnum = function (enumThing) {
    return Object.keys(enumThing)
        .filter(function (key) { return key.match(/^\d{1,2}$/); }) //filter out the reverse mapped integer indexes
        .map(function (key) { return enumThing[key]; });
};
var userHasPermission = function (user, permission) { var _a; return !!((_a = user === null || user === void 0 ? void 0 : user.permissions) === null || _a === void 0 ? void 0 : _a.includes(permission)); };
exports.userHasPermission = userHasPermission;
var OutsetaSubscriptionId;
(function (OutsetaSubscriptionId) {
    OutsetaSubscriptionId["Free"] = "RyW1VgmB";
    OutsetaSubscriptionId["LegacyProfi"] = "VdQGkpQ4";
    OutsetaSubscriptionId["LegacyPrivate"] = "aOW4E3mg";
    OutsetaSubscriptionId["Vacation"] = "rQVPELW6";
    OutsetaSubscriptionId["Collector"] = "NmdeZOQ0";
    OutsetaSubscriptionId["Starter"] = "E9LdG59w";
    OutsetaSubscriptionId["Trader"] = "rmkAZk9g";
    OutsetaSubscriptionId["Professional"] = "vWyXrM9b";
    OutsetaSubscriptionId["Shop"] = "MQvkZb9Y";
    OutsetaSubscriptionId["Powerseller"] = "yWor4N9D";
    OutsetaSubscriptionId["CusNeoxuan"] = "y9qo7qmA";
    OutsetaSubscriptionId["CusRoca"] = "dQGnlom4";
})(OutsetaSubscriptionId = exports.OutsetaSubscriptionId || (exports.OutsetaSubscriptionId = {}));
var SubscriptionId;
(function (SubscriptionId) {
    SubscriptionId[SubscriptionId["Trial"] = 1] = "Trial";
    SubscriptionId[SubscriptionId["Free"] = 2] = "Free";
    SubscriptionId[SubscriptionId["FreeRoca"] = 3] = "FreeRoca";
    SubscriptionId[SubscriptionId["FreeDayPass"] = 4] = "FreeDayPass";
    SubscriptionId[SubscriptionId["Full"] = 5] = "Full";
    SubscriptionId[SubscriptionId["FullPastDue"] = 6] = "FullPastDue";
    SubscriptionId[SubscriptionId["Legacy"] = 7] = "Legacy";
    SubscriptionId[SubscriptionId["Expired"] = 8] = "Expired";
    SubscriptionId[SubscriptionId["Custom"] = 9] = "Custom";
    SubscriptionId[SubscriptionId["FullCancelling"] = 10] = "FullCancelling";
    SubscriptionId[SubscriptionId["No"] = 11] = "No";
})(SubscriptionId = exports.SubscriptionId || (exports.SubscriptionId = {}));
var InventoryFetchState;
(function (InventoryFetchState) {
    InventoryFetchState[InventoryFetchState["IDLE"] = 0] = "IDLE";
    InventoryFetchState[InventoryFetchState["FETCHING"] = 1] = "FETCHING";
    InventoryFetchState[InventoryFetchState["FAILED_DISCONNECTED_ACCOUNT"] = 2] = "FAILED_DISCONNECTED_ACCOUNT";
    InventoryFetchState[InventoryFetchState["FAILED_UNKNOWN"] = 3] = "FAILED_UNKNOWN";
})(InventoryFetchState = exports.InventoryFetchState || (exports.InventoryFetchState = {}));
exports.SUPPORTED_CURRENCIES = ['EUR', 'GBP', 'CAD'];
var Activity;
(function (Activity) {
    Activity["AutopriceArticles"] = "Autoprice Articles";
    Activity["ExportCSV"] = "Export CSV";
    Activity["PublishArticles"] = "Publish Articles";
    Activity["PublishChanges"] = "Publish Changes";
    Activity["ImportCsv"] = "Import Csv";
    Activity["PriceSuggest"] = "Price Suggest";
    Activity["ConnectCardmarket"] = "Connect Cardmarket";
    Activity["PurchaseDaypass"] = "Purchase Day pass";
    Activity["UpgradeSubscription"] = "Upgrade Subscription";
    Activity["PriceGuideArticles"] = "Price Guide Articles";
    Activity["BotTestRun"] = "Bot Test Run";
    Activity["ActivateBot"] = "Activate Bot";
})(Activity = exports.Activity || (exports.Activity = {}));
var GameName;
(function (GameName) {
    GameName["Generic"] = "Generic";
    GameName["Magic"] = "Magic";
    GameName["Yugioh"] = "YuGiOh";
    GameName["Pokemon"] = "Pokemon";
    GameName["Vanguard"] = "Vanguard";
    GameName["FF"] = "FF";
    GameName["DBS"] = "DBS";
    GameName["WS"] = "WS";
    GameName["FAB"] = "FAB";
    GameName["Digimon"] = "Digimon";
    GameName["OnePiece"] = "OnePiece";
    GameName["Lorcana"] = "Lorcana";
    GameName["BSS"] = "BSS";
    GameName["SWU"] = "SWU";
    GameName["Riftbound"] = "Riftbound";
    GameName["Cyberpunk"] = "Cyberpunk";
    GameName["Gundam"] = "Gundam";
    GameName["Sorcery"] = "Sorcery";
})(GameName = exports.GameName || (exports.GameName = {}));
exports.GAME_NAMES = {
    0: GameName.Generic,
    1: GameName.Magic,
    3: GameName.Yugioh,
    6: GameName.Pokemon,
    8: GameName.Vanguard,
    9: GameName.FF,
    10: GameName.WS,
    13: GameName.DBS,
    16: GameName.FAB,
    17: GameName.Digimon,
    18: GameName.OnePiece,
    19: GameName.Lorcana,
    20: GameName.BSS,
    21: GameName.SWU,
    22: GameName.Riftbound,
    23: GameName.Cyberpunk,
    24: GameName.Gundam,
    25: GameName.Sorcery,
};
var IdGame;
(function (IdGame) {
    IdGame[IdGame["Magic"] = 1] = "Magic";
    IdGame[IdGame["Yugioh"] = 3] = "Yugioh";
    IdGame[IdGame["Pokemon"] = 6] = "Pokemon";
    IdGame[IdGame["Vanguard"] = 8] = "Vanguard";
    IdGame[IdGame["FF"] = 9] = "FF";
    IdGame[IdGame["DBS"] = 13] = "DBS";
    IdGame[IdGame["WS"] = 10] = "WS";
    IdGame[IdGame["FAB"] = 16] = "FAB";
    IdGame[IdGame["Digimon"] = 17] = "Digimon";
    IdGame[IdGame["OnePiece"] = 18] = "OnePiece";
    IdGame[IdGame["Lorcana"] = 19] = "Lorcana";
    IdGame[IdGame["BSS"] = 20] = "BSS";
    IdGame[IdGame["SWU"] = 21] = "SWU";
    IdGame[IdGame["Riftbound"] = 22] = "Riftbound";
    IdGame[IdGame["Cyberpunk"] = 23] = "Cyberpunk";
    IdGame[IdGame["Gundam"] = 24] = "Gundam";
    IdGame[IdGame["Sorcery"] = 25] = "Sorcery";
})(IdGame = exports.IdGame || (exports.IdGame = {}));
exports.GAME_IDS = Object.values(IdGame).filter(function (id) { return typeof id === 'number'; });
var CardExtraAttribute;
(function (CardExtraAttribute) {
    // Foil = 'isFoil',
    CardExtraAttribute["Signed"] = "isSigned";
    CardExtraAttribute["Playset"] = "isPlayset";
    CardExtraAttribute["FirstEd"] = "isFirstEd";
    // ReverseHolo = 'isReverseHolo',
})(CardExtraAttribute = exports.CardExtraAttribute || (exports.CardExtraAttribute = {}));
var PriceStategyTarget;
(function (PriceStategyTarget) {
    PriceStategyTarget["buyPrice"] = "buyPrice";
    PriceStategyTarget["sellPrice"] = "sellPrice";
})(PriceStategyTarget = exports.PriceStategyTarget || (exports.PriceStategyTarget = {}));
var PriceGuideMetrics;
(function (PriceGuideMetrics) {
    PriceGuideMetrics["Trend"] = "Trend";
    PriceGuideMetrics["AVG1"] = "AVG1";
    PriceGuideMetrics["AVG7"] = "AVG7";
    PriceGuideMetrics["AVG30"] = "AVG30";
})(PriceGuideMetrics = exports.PriceGuideMetrics || (exports.PriceGuideMetrics = {}));
var CardmarketStatus;
(function (CardmarketStatus) {
    CardmarketStatus[CardmarketStatus["normal"] = 1] = "normal";
    CardmarketStatus[CardmarketStatus["slow"] = 2] = "slow";
    CardmarketStatus[CardmarketStatus["down"] = 3] = "down";
})(CardmarketStatus = exports.CardmarketStatus || (exports.CardmarketStatus = {}));
var Reputation;
(function (Reputation) {
    Reputation[Reputation["NewSeller"] = 0] = "NewSeller";
    Reputation[Reputation["Outstanding"] = 1] = "Outstanding";
    Reputation[Reputation["VeryGood"] = 2] = "VeryGood";
    Reputation[Reputation["Good"] = 3] = "Good";
    Reputation[Reputation["Average"] = 4] = "Average";
})(Reputation = exports.Reputation || (exports.Reputation = {}));
exports.REPUTATIONS = arrayFromEnum(Reputation);
var SellerLevel;
(function (SellerLevel) {
    SellerLevel[SellerLevel["Private"] = 0] = "Private";
    SellerLevel[SellerLevel["Professional"] = 1] = "Professional";
    SellerLevel[SellerLevel["Powerseller"] = 2] = "Powerseller";
})(SellerLevel = exports.SellerLevel || (exports.SellerLevel = {}));
exports.SELLER_LEVELS = arrayFromEnum(SellerLevel);
var CardLanguage;
(function (CardLanguage) {
    CardLanguage[CardLanguage["English"] = 1] = "English";
    CardLanguage[CardLanguage["French"] = 2] = "French";
    CardLanguage[CardLanguage["German"] = 3] = "German";
    CardLanguage[CardLanguage["Spanish"] = 4] = "Spanish";
    CardLanguage[CardLanguage["Italian"] = 5] = "Italian";
    CardLanguage[CardLanguage["S-Chinese"] = 6] = "S-Chinese";
    CardLanguage[CardLanguage["Japanese"] = 7] = "Japanese";
    CardLanguage[CardLanguage["Portuguese"] = 8] = "Portuguese";
    CardLanguage[CardLanguage["Russian"] = 9] = "Russian";
    CardLanguage[CardLanguage["Korean"] = 10] = "Korean";
    CardLanguage[CardLanguage["T-Chinese"] = 11] = "T-Chinese";
    CardLanguage[CardLanguage["Dutch"] = 12] = "Dutch";
    CardLanguage[CardLanguage["Polish"] = 13] = "Polish";
    CardLanguage[CardLanguage["Czech"] = 14] = "Czech";
    CardLanguage[CardLanguage["Hungarian"] = 15] = "Hungarian";
    CardLanguage[CardLanguage["Indonesian"] = 16] = "Indonesian";
    CardLanguage[CardLanguage["Thai"] = 17] = "Thai";
})(CardLanguage = exports.CardLanguage || (exports.CardLanguage = {}));
exports.CARD_LANGUAGES = Object.keys(CardLanguage)
    .filter(function (key) { return key.match(/^\d{1,2}$/); }) //filter out the reverse mapped integer indexes
    .map(function (key) { return ({
    label: CardLanguage[Number(key)],
    value: Number(key),
}); });
exports.CARDMARKET_CONDITIONS = ['MT', 'NM', 'EX', 'GD', 'LP', 'PL', 'PO'];
var ConditionEnum;
(function (ConditionEnum) {
    ConditionEnum[ConditionEnum["MT"] = 0] = "MT";
    ConditionEnum[ConditionEnum["NM"] = 1] = "NM";
    ConditionEnum[ConditionEnum["EX"] = 2] = "EX";
    ConditionEnum[ConditionEnum["GD"] = 3] = "GD";
    ConditionEnum[ConditionEnum["LP"] = 4] = "LP";
    ConditionEnum[ConditionEnum["PL"] = 5] = "PL";
    ConditionEnum[ConditionEnum["PO"] = 6] = "PO";
})(ConditionEnum = exports.ConditionEnum || (exports.ConditionEnum = {}));
exports.CONDITIONS = arrayFromEnum(ConditionEnum);
var AnyYesNo;
(function (AnyYesNo) {
    AnyYesNo["Any"] = "any";
    AnyYesNo[AnyYesNo["Yes"] = 1] = "Yes";
    AnyYesNo[AnyYesNo["No"] = 0] = "No";
})(AnyYesNo = exports.AnyYesNo || (exports.AnyYesNo = {}));
var ChannelFilterOptions;
(function (ChannelFilterOptions) {
    ChannelFilterOptions["powertools"] = "powertools";
    ChannelFilterOptions["cardmarket"] = "cardmarket";
    ChannelFilterOptions["shopify"] = "shopify";
    ChannelFilterOptions["cardtrader"] = "cardtrader";
})(ChannelFilterOptions = exports.ChannelFilterOptions || (exports.ChannelFilterOptions = {}));
var ExpansionSortOptions;
(function (ExpansionSortOptions) {
    ExpansionSortOptions["alphabet"] = "alphabet";
    ExpansionSortOptions["cn"] = "cn";
    ExpansionSortOptions["rarityCn"] = "rarityCn";
    ExpansionSortOptions["rarityAlphabet"] = "rarityAlphabet";
})(ExpansionSortOptions = exports.ExpansionSortOptions || (exports.ExpansionSortOptions = {}));
var YugiohRaritySliderLabels;
(function (YugiohRaritySliderLabels) {
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["Unk"] = 1] = "Unk";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["Ovs"] = 2] = "Ovs";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["Tkn"] = 3] = "Tkn";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["C"] = 4] = "C";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["R"] = 5] = "R";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["Spec"] = 6] = "Spec";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["SR"] = 7] = "SR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["UR"] = 8] = "UR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["ScR"] = 9] = "ScR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["UtR"] = 10] = "UtR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["GR"] = 11] = "GR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["SFR"] = 12] = "SFR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["MSR"] = 13] = "MSR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["SHR"] = 14] = "SHR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["PlR"] = 15] = "PlR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["GUR"] = 16] = "GUR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["GScR"] = 17] = "GScR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["CR"] = 18] = "CR";
    YugiohRaritySliderLabels[YugiohRaritySliderLabels["AltR"] = 19] = "AltR";
})(YugiohRaritySliderLabels = exports.YugiohRaritySliderLabels || (exports.YugiohRaritySliderLabels = {}));
var DataFreshness;
(function (DataFreshness) {
    DataFreshness[DataFreshness["twoHours"] = 1] = "twoHours";
    DataFreshness[DataFreshness["oneDay"] = 2] = "oneDay";
    DataFreshness[DataFreshness["twoDays"] = 3] = "twoDays";
})(DataFreshness = exports.DataFreshness || (exports.DataFreshness = {}));
var PricingJobType;
(function (PricingJobType) {
    PricingJobType["TestRun"] = "testRun";
    PricingJobType["Nightly"] = "nightly";
    PricingJobType["ManualRun"] = "manualRun";
})(PricingJobType = exports.PricingJobType || (exports.PricingJobType = {}));
//# sourceMappingURL=types.js.map